import { Link } from "react-router-dom";
import { Star, Phone, ArrowRight } from "lucide-react";
import { FONT_HEAD, FONT_BODY, NAVY, GOLD, PHONE, PHONE_LINK } from "../lib/constants";

export const StarRating = ({ count = 5 }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={`star-${i}`} size={14} fill={GOLD} stroke={GOLD} />
    ))}
  </div>
);

export const SectionBadge = ({ children, dark = false }) => (
  <div
    className="inline-block mb-3 px-4 py-1 text-xs font-bold tracking-[0.2em] uppercase"
    style={{
      background: dark ? "rgba(212,168,67,0.2)" : "rgba(212,168,67,0.14)",
      color: dark ? GOLD : "#b8922a",
      fontFamily: FONT_HEAD,
    }}
  >
    {children}
  </div>
);

export const PageHero = ({ badge, title, subtitle, testid }) => (
  <section
    data-testid={testid}
    className="pt-16 md:pt-20"
    style={{ background: NAVY }}
  >
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 text-center">
      <SectionBadge dark>{badge}</SectionBadge>
      <h1
        className="text-4xl sm:text-5xl font-bold text-white leading-tight"
        style={{ fontFamily: FONT_HEAD, letterSpacing: "-0.02em" }}
      >
        {title}
      </h1>
      <p
        className="mt-5 text-base md:text-lg max-w-2xl mx-auto leading-relaxed"
        style={{ color: "rgba(255,255,255,0.7)", fontFamily: FONT_BODY }}
      >
        {subtitle}
      </p>
    </div>
  </section>
);

export const CTABanner = ({ testid = "cta-banner" }) => (
  <section data-testid={testid} className="py-16 md:py-20" style={{ background: NAVY }}>
    <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: FONT_HEAD }}>
        Ready for a <span style={{ color: GOLD }}>Spotless Space</span>?
      </h2>
      <p className="text-base mb-8" style={{ color: "rgba(255,255,255,0.7)", fontFamily: FONT_BODY }}>
        Get your free, no-commitment quote today. Licensed & insured in Naples, FL.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href={PHONE_LINK}
          data-testid={`${testid}-call-btn`}
          className="flex items-center justify-center gap-2 px-8 py-4 text-base font-bold transition-all duration-300 hover:opacity-90"
          style={{ background: GOLD, color: NAVY, fontFamily: FONT_BODY }}
        >
          <Phone size={18} />
          {PHONE}
        </a>
        <Link
          to="/contact"
          data-testid={`${testid}-quote-btn`}
          className="flex items-center justify-center gap-2 px-8 py-4 text-base font-bold border-2 text-white transition-all duration-300 hover:bg-white hover:text-[#1B3A6B]"
          style={{ borderColor: "rgba(255,255,255,0.5)", fontFamily: FONT_BODY }}
        >
          Get a Free Quote
          <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  </section>
);
